// VÝBER ZÁKAZKY — jedno pole pre celý Matrix (0.J): karty Matrixu (Z…) aj MKsoft zákazky bez karty v JEDNOM zozname, hľadanie podľa
// Z čísla, názvu, MKsoft čísla, MKsoft názvu a firmy. MKsoft zákazka, ktorá už má kartu = tá karta (vedľa seba Z… aj MKsoft číslo).
// MKsoft zákazka bez karty: Matrix ponúkne spárovanie s kartou firmy bez MKsoft čísla (POST /api/mksoft-zakazky/:cislo/sparovat, 23.3.A — vzor
// Predajňa, žiadna druhá karta) alebo založenie ukončenej karty z MKsoftu (POST /api/reklamacie/zakazka-z-mksoftu, 18.8.13). Nikdy ručné číslo.
// REK_REGISTER_V1D — Mirko 21. 10. 2026 (Upraviť reklamácie): „toto je nezmysel neviem vybrať zákazku číslo MKsoft iba matrix“ (Kronika matrix 2851).
// REK_REGISTER_V1E — Mirko 21. 10. 2026: „tu bude predvolené ako vzdy mksoft cislo, čo nevies?“ → MKsoft číslo je predvolená identita (23.3.B): v zozname aj vo vybranom
// zázname je MKsoft číslo PRVÉ (zelené; červené „bez MKsoft čísla“), potom názov stavby, Z… ako druhý údaj.
// Props: value (project_id) · onChange(project_id, { project }) · customerId (karty firmy prvé; firma pre spárovanie / založenie)
//        · projects (ak ich má rodič načítané) · ajUkoncene (true — reklamácia prichádza po odovzdaní) · disabled · zalozitApi · kompakt
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { Btn } from './Btn.jsx'
import { COLORS, TYPO, RADIUS, hladaj } from '../theme.js'

const kodKarty = (p) => String((p && (p.zakazka_code || p.mksoft_cislo)) || '').trim()
const stavSlovom = (p) => p.status === 'done' ? 'ukončená' + (p.zaruka_do ? ', v záruke do ' + p.zaruka_do : '') : (p.status === 'active' ? 'aktívna' : (p.status || ''))
const stit = (farba, pozadie, text) => <span style={{ fontSize: 11, fontWeight: 800, color: farba, background: pozadie, borderRadius: 999, padding: '1px 8px', whiteSpace: 'nowrap' }}>{text}</span>

export default function VyberZakazky({ value = '', onChange, customerId = '', projects = null, ajUkoncene = true, disabled = false, zalozitApi = '/api/reklamacie/zakazka-z-mksoftu', kompakt = false, autoFocus = false }) {
  const [proj, setProj] = useState(projects)
  const [mk, setMk] = useState(null)
  const [q, setQ] = useState('')
  const [kurzor, setKurzor] = useState(0)
  const [otvorene, setOtvorene] = useState(!value)
  const [kand, setKand] = useState(null)      // MKsoft zákazka bez karty: { z, karty } — ponuka spárovania / založenia
  const [busy, setBusy] = useState(false)
  const [chyba, setChyba] = useState('')
  const inp = useRef(null)
  useEffect(() => { if (projects) setProj(projects) }, [projects])
  useEffect(() => {
    let on = true
    if (!projects) fetchAuth('/api/projects').then(r => r.ok ? r.json() : []).then(d => { if (on) setProj(Array.isArray(d) ? d : (d.rows || [])) }).catch(() => { if (on) setProj([]) })
    fetchAuth('/api/mksoft-zakazky').then(r => r.ok ? r.json() : null).then(j => { if (on) setMk(j) }).catch(() => {})
    return () => { on = false }
  }, [projects])
  useEffect(() => { if (!value) setOtvorene(true) }, [value])

  const mkPodla = useMemo(() => { const m = new Map(); for (const z of ((mk && mk.zoznam) || [])) m.set(String(z.cislo), z); return m }, [mk])
  const firma = String(customerId || '')
  const polozky = useMemo(() => {
    const out = []
    for (const p of (proj || [])) {
      if (!ajUkoncene && p.status === 'done' && String(p.id) !== String(value)) continue
      const c = kodKarty(p); const z = c ? mkPodla.get(c) : null
      out.push({ typ: 'karta', id: String(p.id), p, kod: c, mkNazov: z ? String(z.nazov || '') : '', firma: String(p.customerId || ''),
        text: p.id + ' ' + (p.name || '') + ' ' + c + ' ' + (z ? z.nazov : '') + ' ' + String(p.mksoft_cisla_dalsie || '').replace(/,/g, ' ') })   // ZAKAZKA_CISLA_V1: aj ďalšie čísla
    }
    for (const z of ((mk && mk.zoznam) || [])) {
      if (z.sparovane || z.obsadene) continue   // s kartou = karta vyššie; kód reklamácie = náklady opravy, nie stavba
      if (!ajUkoncene && z.ukoncena) continue
      out.push({ typ: 'mksoft', id: 'mk:' + z.cislo, z, kod: String(z.cislo), firma: z.zakaznik ? String(z.zakaznik.id) : '',
        text: z.cislo + ' ' + (z.nazov || '') + ' ' + (z.zakaznik ? z.zakaznik.name : '') })
    }
    const filt = q ? out.filter(x => hladaj(x.text, q)) : out
    const jeFirmy = (x) => (firma && x.firma === firma) ? 1 : 0
    return filt.sort((a, b) => (jeFirmy(b) - jeFirmy(a)) || ((a.typ === 'karta' ? 0 : 1) - (b.typ === 'karta' ? 0 : 1)) || String(b.id).localeCompare(String(a.id)))
  }, [proj, mk, mkPodla, q, firma, ajUkoncene, value])
  useEffect(() => { setKurzor(0) }, [q, proj, mk])
  const vybrany = useMemo(() => (proj || []).find(p => String(p.id) === String(value)) || null, [proj, value])

  const vyberKartu = (p) => { onChange && onChange(String(p.id), { project: p }); setOtvorene(false); setQ(''); setKand(null); setChyba('') }
  const vyber = (x) => {
    if (!x || disabled) return
    if (x.typ === 'karta') return vyberKartu(x.p)
    const f = firma || (x.z.zakaznik ? String(x.z.zakaznik.id) : '')
    const karty = f ? (proj || []).filter(p => String(p.customerId) === f && !kodKarty(p)) : []
    setKand({ z: x.z, firma: f, karty }); setChyba('')
  }
  const naKlaves = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setKurzor(k => Math.min(k + 1, Math.max(polozky.length - 1, 0))) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setKurzor(k => Math.max(k - 1, 0)) }
    else if (e.key === 'Enter') { e.preventDefault(); vyber(polozky[kurzor]) }
    else if (e.key === 'Escape' && q) { e.preventDefault(); setQ('') }
  }
  // 23.3.A — spárovanie existujúcej karty s MKsoft číslom: ten istý zápis ako na karte zákazky (Info › MKsoft č.)
  const sparuj = async (p) => {
    if (!kand) return
    setBusy(true); setChyba('')
    try {
      const r = await fetchAuth('/api/mksoft-zakazky/' + encodeURIComponent(kand.z.cislo) + '/sparovat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ project_id: p.id }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || ('Chyba ' + r.status))
      const np = { ...p, zakazka_code: kand.z.cislo, mksoft_cislo: kand.z.cislo }
      setProj(list => (list || []).map(x => String(x.id) === String(p.id) ? np : x))
      setMk(m => m ? { ...m, zoznam: m.zoznam.map(z => z.cislo === kand.z.cislo ? { ...z, sparovane: { typ: 'zakazka', id: p.id, name: p.name, nazov: p.name, status: p.status } } : z) } : m)
      vyberKartu(np)
    } catch (e) { setChyba(e.message) } finally { setBusy(false) }
  }
  // 18.8.13 — iná stavba: ukončená karta z MKsoftu (názov, číslo a firma z MKsoftu)
  const zaloz = async () => {
    if (!kand) return
    setBusy(true); setChyba('')
    try {
      const r = await fetchAuth(zalozitApi, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ mksoft_cislo: kand.z.cislo, customer_id: kand.firma }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || ('Chyba ' + r.status))
      const np = { id: j.project_id, name: j.nazov || kand.z.nazov, status: 'done', customerId: kand.firma, zakazka_code: kand.z.cislo, mksoft_cislo: kand.z.cislo }
      setProj(list => [np, ...(list || []).filter(x => String(x.id) !== String(np.id))])
      setMk(m => m ? { ...m, zoznam: m.zoznam.map(z => z.cislo === kand.z.cislo ? { ...z, sparovane: { typ: 'zakazka', id: np.id, name: np.name, nazov: np.name, status: 'done' } } : z) } : m)
      vyberKartu(np)
    } catch (e) { setChyba(e.message) } finally { setBusy(false) }
  }
  const smie = !mk || mk.smie !== false

  // Vybraté — jeden riadok: Z číslo · názov · stav · MKsoft číslo (zelené) / bez čísla (červené) · Zmeniť
  if (value && !otvorene) {
    const c = vybrany ? kodKarty(vybrany) : ''
    const z = c ? mkPodla.get(c) : null
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: TYPO.sizes.sm }}>{/* REK_REGISTER_V1E — MKsoft číslo prvé */}
        {vybrany ? (c ? <b style={{ fontFamily: TYPO.mono, color: '#15803d' }}>✓ {c}</b> : stit('#b91c1c', '#fee2e2', '✗ bez MKsoft čísla')) : null}
        <span style={{ fontWeight: 600 }}>{vybrany ? (vybrany.name || '') : ''}{z && z.nazov && z.nazov !== (vybrany && vybrany.name) ? <span style={{ color: COLORS.muted, fontWeight: 400 }}> (MKsoft: {z.nazov})</span> : null}</span>
        <span style={{ color: COLORS.muted, fontFamily: TYPO.mono }}>{value}</span>
        {vybrany && <span style={{ color: COLORS.muted }}>{stavSlovom(vybrany)}</span>}
        {!disabled && <Btn size="sm" onClick={() => { setOtvorene(true); setTimeout(() => inp.current && inp.current.focus(), 0) }}>Zmeniť</Btn>}
      </div>
    )
  }

  if (kand) {
    const z = kand.z
    return (
      <div style={{ padding: 10, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, background: COLORS.bg, fontSize: TYPO.sizes.sm }}>
        <div style={{ marginBottom: 6 }}><b style={{ fontFamily: TYPO.mono }}>MKsoft {z.cislo}</b> <b>{z.nazov || '(bez názvu)'}</b>{z.zakaznik ? <span style={{ color: COLORS.muted }}> · {z.zakaznik.name}</span> : null} <span style={{ color: COLORS.muted }}>— nemá kartu v Matrixe.</span></div>
        {!kand.firma && <div style={{ color: '#b45309', marginBottom: 6 }}>MKsoft zákazka nemá v Matrixe partnera — vyber najprv firmu, potom zákazku.</div>}
        {kand.firma && kand.karty.length > 0 && (
          <div style={{ marginBottom: 6 }}>
            <div style={{ color: COLORS.muted, marginBottom: 4 }}>Firma má v Matrixe karty bez MKsoft čísla. Ak je to tá istá stavba, spáruj ju (jedna MKsoft zákazka = jedna karta, 23.3.A):</div>
            {kand.karty.map(p => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderTop: `1px solid ${COLORS.line}` }}>
                <span style={{ fontFamily: TYPO.mono }}>{p.id}</span><span style={{ flex: 1, minWidth: 0 }}>{p.name}<span style={{ color: COLORS.muted }}> · {stavSlovom(p)}</span></span>
                {smie && <Btn size="sm" variant="nav" onClick={() => sparuj(p)} disabled={busy || disabled}>Spárovať</Btn>}
              </div>))}
          </div>)}
        {kand.firma && kand.karty.length === 0 && <div style={{ color: COLORS.muted, marginBottom: 6 }}>Firma nemá v Matrixe kartu bez MKsoft čísla — vznikne ukončená karta z MKsoftu (dielo je odovzdané).</div>}
        {!smie && <div style={{ color: '#b45309', marginBottom: 6 }}>Spárovať a zakladať smie office, back office alebo vedenie.</div>}
        {chyba && <div style={{ color: '#b91c1c', marginBottom: 6 }}>{chyba}</div>}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          {kand.firma && smie && <Btn size="sm" variant={kand.karty.length ? undefined : 'nav'} onClick={zaloz} disabled={busy || disabled}>{busy ? 'Pracujem…' : (kand.karty.length ? 'Je to iná stavba — založiť ukončenú kartu z MKsoftu' : 'Založiť ukončenú kartu z MKsoftu')}</Btn>}
          <Btn size="sm" onClick={() => setKand(null)} disabled={busy}>Späť</Btn>
        </div>
      </div>
    )
  }

  const riadok = (x, i) => {
    const akt = i === kurzor
    const karta = x.typ === 'karta'
    return (
      <div key={x.id} onClick={() => vyber(x)} onMouseEnter={() => setKurzor(i)}
        style={{ display: 'flex', alignItems: 'center', gap: 10, border: '1px solid ' + (akt ? (COLORS.nav || '#1d4ed8') : COLORS.line), background: akt ? (COLORS.navBg || '#eff6ff') : '#fff', borderRadius: 10, padding: '5px 10px', marginBottom: 4, cursor: disabled ? 'default' : 'pointer' }}>
        <b style={{ fontFamily: TYPO.mono, minWidth: 68, fontSize: TYPO.sizes.sm, color: karta ? (x.kod ? '#15803d' : '#b91c1c') : '#1d4ed8' }}>{karta ? (x.kod || '✗ —') : x.z.cislo}</b>{/* REK_REGISTER_V1E — MKsoft číslo prvé (23.3.B) */}
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ fontWeight: 600, fontSize: TYPO.sizes.sm }}>{karta ? (x.p.name || '(bez názvu)') : (x.z.nazov || '(bez názvu)')}{karta && x.mkNazov && x.mkNazov !== x.p.name ? <span style={{ color: COLORS.muted, fontWeight: 400 }}> (MKsoft: {x.mkNazov})</span> : null}</span>
          <small style={{ display: 'block', color: COLORS.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {karta ? (x.p.id + ' · ' + stavSlovom(x.p) + (x.kod ? '' : ' · bez MKsoft čísla — spáruj na karte zákazky'))
              : ('MKsoft' + (x.z.datum_od ? ' od ' + String(x.z.datum_od).slice(0, 10) : '') + (x.z.zakaznik ? ' · ' + x.z.zakaznik.name : (x.z.firmaid ? ' · firma ' + x.z.firmaid + ' (v Matrixe nie je)' : '')) + (x.z.ukoncena ? ' · ukončená' : '') + ' · bez karty v Matrixe')}
          </small>
        </span>
        {karta ? (x.kod ? stit('#15803d', '#dcfce7', '✓ MKsoft') : stit('#b91c1c', '#fee2e2', '✗ bez čísla')) : stit('#1d4ed8', '#eff6ff', 'z MKsoftu — bez karty')}
      </div>
    )
  }

  const nacitaneMk = mk && mk.pocet ? mk.pocet : 0
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
        <input ref={inp} value={q} onChange={e => setQ(e.target.value)} onKeyDown={naKlaves} disabled={disabled} autoFocus={autoFocus}
          placeholder="MKsoft číslo, názov stavby alebo Z číslo…"
          style={{ flex: 1, minWidth: 200, padding: '7px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, fontSize: TYPO.sizes.md }} />
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{proj ? (proj.length + ' kariet') : 'načítavam…'}{mk ? ' · ' + nacitaneMk + ' MKsoft' + (mk.nacitane_at ? ' (' + String(mk.nacitane_at).slice(0, 10) + ')' : '') : ''}</span>
        {value && <Btn size="sm" onClick={() => { setOtvorene(false); setQ('') }}>Zavrieť</Btn>}
      </div>
      <div style={{ maxHeight: kompakt ? 180 : 280, overflow: 'auto' }}>
        {polozky.slice(0, 60).map((x, i) => riadok(x, i))}
        {proj && mk && !polozky.length && <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, padding: 6 }}>Nič sa nenašlo — skús číslo MKsoft zákazky alebo časť názvu.</div>}
        {polozky.length > 60 && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, padding: 4 }}>… ďalších {polozky.length - 60}, upresni hľadanie</div>}
      </div>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>MKsoft číslo je číslo zákazky (23.3.B); karty Matrixu aj MKsoft zákazky bez karty v jednom zozname · ↑↓ Enter · MKsoft zákazka bez karty sa spáruje s kartou firmy alebo založí ukončenú kartu (23.3.A, 18.8.13)</div>
    </div>
  )
}
